import * as React from "react";
import { Check, ChevronRight, ClipboardList } from "lucide-react";
import { cn } from "@/lib/utils";
import { PlayerCardFormSummary } from "../../../services/bedrock";

interface FormRecordCardProps {
  form: PlayerCardFormSummary;
  onClick: () => void;
  variant: "selected" | "option";
  isCurrent?: boolean;
}

const FormRecordCard: React.FC<FormRecordCardProps> = ({ form, onClick, variant, isCurrent = false }) => {
  const name = form.displayName || form.introTitle || "Untitled form";
  const subtitle = form.introTitle && form.introTitle !== name ? form.introTitle : null;

  return (
    <button
      type="button"
      onClick={onClick}
      title={name}
      aria-pressed={variant === "option" ? isCurrent : undefined}
      className={cn(
        "group flex w-full cursor-pointer items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition-all",
        "hover:-translate-y-0.5 hover:border-primary/60 hover:shadow-md focus-visible:ring-3 focus-visible:ring-primary/30 focus-visible:outline-none",
        variant === "selected" && "max-w-sm border-primary/30 bg-gradient-to-r from-primary/5 to-white",
        isCurrent && "border-primary ring-2 ring-primary/20"
      )}
    >
      <span
        className={cn(
          "flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary",
          (variant === "selected" || isCurrent) && "bg-primary text-white"
        )}
      >
        <ClipboardList className="size-5" />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="line-clamp-2 text-sm font-semibold leading-snug text-gray-900">{name}</span>
        {subtitle && <span className="line-clamp-1 text-xs text-gray-500">{subtitle}</span>}
      </span>
      {variant === "selected" ? (
        <span className="flex shrink-0 items-center gap-0.5 text-xs font-semibold text-primary opacity-70 transition-opacity group-hover:opacity-100">
          Change
          <ChevronRight className="size-4 transition-transform group-hover:translate-x-0.5" />
        </span>
      ) : (
        isCurrent && <Check className="size-5 shrink-0 text-primary" />
      )}
    </button>
  );
};
export default FormRecordCard;
